import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import type { Disruption } from '../../api/status/interface';
import { actions as statusSliceActions } from '../../data/status/logic';
import type { StoreState } from '../../data/store';

export interface StatusHookState {
  disruptions: Disruption[];
  actions: StoreState['status']['actions'];
}

interface StatusHookHandler {
  fetchDisruptions(): void;
}

const useStatusHook = (): [StatusHookState, StatusHookHandler] => {
  const dispatch = useDispatch();
  const { disruptions = [], actions } = useSelector(
    (s: StoreState) => s['status']
  );

  const handler = React.useMemo(
    () => ({
      fetchDisruptions: () => {
        dispatch(statusSliceActions.fetchDisruptions());
      },
    }),
    []
  );

  return [{ disruptions, actions }, handler];
};

export default useStatusHook;
